export default __webpack_public_path__ + "static/media/CM.682aa075.svg";